/* Vendors */
import { MT } from '@/services/metrics/types/scripts.types'
/* Types */
import {
  ParamsDefault,
  ParamsPageView,
} from '@/services/metrics/types/service.types'

/* Classes */
import { Metric } from '@/services/metrics/models/Metrics'
import vendorMyTarget from '@/services/metrics/vendor/my-target'

const TYPE_EVENT = 'reachGoal'

export class MyTarget extends Metric {
  #provider!: MT

  async initVendor() {
    try {
      // Инициализируем вендор метрики
      await vendorMyTarget(document, window, 'tmr-code')

      this.#provider = window._tmr
    } catch (error) {
      this.exceptionError(error)
    }
  }

  eventPageView({ mt }: ParamsPageView) {
    if (!mt) return

    this.#provider?.push({
      type: TYPE_EVENT,
      id: this.ids.mainId,
      goal: mt,
    })

    if (!this.ids.cityId) return

    this.#provider?.push({
      type: TYPE_EVENT,
      id: this.ids.cityId,
      goal: mt,
    })
  }

  eventSendGoal({ mt }: ParamsDefault) {
    if (!mt) return

    this.#provider?.push({
      type: TYPE_EVENT,
      id: this.ids.mainId,
      goal: mt,
    })

    if (!this.ids.cityId) return

    this.#provider?.push({
      type: TYPE_EVENT,
      id: this.ids.cityId,
      goal: mt,
    })
  }
}
